import {
  LIST_SUMMARY_RECOMMENDATION_REQUEST,
  LIST_SUMMARY_RECOMMENDATION_SUCCESS,
  LIST_SUMMARY_RECOMMENDATION_FAILURE,
  LIST_SUMMARY_RECOMMENDATION_RESET,
  LIST_SUMMARY_RECOMMENDATION_SUMARY_REQUEST,
  LIST_SUMMARY_RECOMMENDATION_SUMARY_SUCCESS,
  LIST_SUMMARY_RECOMMENDATION_SUMARY_FAILURE,
  CREATE_SUMMARY_RECOMMENDATION_REQUEST,
  CREATE_SUMMARY_RECOMMENDATION_SUCCESS,
  CREATE_SUMMARY_RECOMMENDATION_FAILURE,
  DETAIL_SUMMARY_RECOMMENDATION_REQUEST,
  DETAIL_SUMMARY_RECOMMENDATION_SUCCESS,
  DETAIL_SUMMARY_RECOMMENDATION_FAILURE,
  UPDATE_SUMMARY_RECOMMENDATION_REQUEST,
  UPDATE_SUMMARY_RECOMMENDATION_SUCCESS,
  UPDATE_SUMMARY_RECOMMENDATION_FAILURE,
  DELETE_SUMMARY_RECOMMENDATION_REQUEST,
  DELETE_SUMMARY_RECOMMENDATION_SUCCESS,
  DELETE_SUMMARY_RECOMMENDATION_FAILURE
} from '../../constants/summary-recommendations'

const initialState = {
  loading: false,
  loadingDelete: false,
  summaryRecomendations: [],
  summaryRecommendation: {},
  summaryRecommendationSummaries: [],
  error: '',
  pageable: {}
}

const summaryRecommendationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SUMMARY_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryRecomendations: action.payload,
        pageable: action.pageable
      }
    case LIST_SUMMARY_RECOMMENDATION_FAILURE:
      return {
        ...state,
        loading: false,
        summaryRecomendations: [],
        error: action.payload
      }
    case LIST_SUMMARY_RECOMMENDATION_RESET:
      return {
        ...state,
        loading: false,
        summaryRecomendations: [],
        error: ''
      }
    case LIST_SUMMARY_RECOMMENDATION_SUMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SUMMARY_RECOMMENDATION_SUMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryRecommendationSummaries: action.payload
      }
    case LIST_SUMMARY_RECOMMENDATION_SUMARY_FAILURE:
      return {
        ...state,
        loading: false,
        summaryRecommendationSummaries: [],
        error: action.payload
      }
    case CREATE_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case CREATE_SUMMARY_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case CREATE_SUMMARY_RECOMMENDATION_FAILURE:
      return {
        ...state,
        loading: false,
        summaryRecommendation: {},
        error: action.payload
      }
    case DETAIL_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        summaryRecommendation: {}
      }
    case DETAIL_SUMMARY_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        summaryRecommendation: action.payload
      }
    case DETAIL_SUMMARY_RECOMMENDATION_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        summaryRecommendation: {},
        error: action.payload
      }
    case UPDATE_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SUMMARY_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case UPDATE_SUMMARY_RECOMMENDATION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SUMMARY_RECOMMENDATION_SUCCESS:
      const summaryRecomendationId = action.payload
      const findIndex = state.summaryRecomendations.findIndex(summaryRecommendation => summaryRecommendation.id === summaryRecomendationId)
      state.summaryRecomendations.splice(findIndex, 1)

      return {
        ...state,
        loadingDelete: false,
        summaryRecomendations: state.summaryRecomendations
      }
    case DELETE_SUMMARY_RECOMMENDATION_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        summaryRecommendation: {},
        error: action.payload
      }
    default:
      return state
  }
}

export default summaryRecommendationReducer

